
// src/reducers/kpi-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'

import { 
  FETCH_KPIS,
  FETCH_KPIS_REQUESTED,
  FETCH_KPIS_COMPLETED,
  FETCH_KPIS_FAILED,
  FETCH_CHART_KPIS,
  FETCH_CHART_KPIS_REQUESTED,
  FETCH_CHART_KPIS_COMPLETED,
  FETCH_CHART_KPIS_FAILED,
  FETCH_GROUP_KPIS,
  FETCH_GROUP_KPIS_REQUESTED,
  FETCH_GROUP_KPIS_COMPLETED,
  FETCH_GROUP_KPIS_FAILED,
  FETCH_COMPARISON_KPIS,
  FETCH_COMPARISON_KPIS_REQUESTED,
  FETCH_COMPARISON_KPIS_COMPLETED,
  FETCH_COMPARISON_KPIS_FAILED,
  FETCH_KPI,
  FETCH_KPI_REQUESTED,
  FETCH_KPI_COMPLETED,
  FETCH_KPI_FAILED,
  FETCH_CLOSED_KPIS,
  FETCH_CLOSED_KPIS_REQUESTED,
  FETCH_CLOSED_KPIS_COMPLETED,
  FETCH_CLOSED_KPIS_FAILED,
  CREATE_KPI,
  CREATE_KPI_REQUESTED,
  CREATE_KPI_COMPLETED,
  CREATE_KPI_FAILED,
  UPDATE_KPI,
  UPDATE_KPI_REQUESTED,
  UPDATE_KPI_COMPLETED,
  UPDATE_KPI_FAILED,
  DELETE_KPI,
  DELETE_KPI_REQUESTED,
  DELETE_KPI_COMPLETED,
  DELETE_KPI_FAILED,
  SORT_KPIS,
  SORT_KPIS_REQUESTED,
  SORT_KPIS_COMPLETED,
  SORT_KPIS_FAILED,
  CLEAR_KPIS,
  CLEAR_CLOSED_KPIS,
  KEEP_SCROLL_POSITION,
} from '../actions/kpi'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  isUpdating: false,
  isUpdateFailed: false,
  items: undefined,
  closedItems: undefined,
  hasMoreClosedItems: true,
  scrollPosition: undefined,
}

export default function kpiReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_KPIS_REQUESTED:
  case FETCH_GROUP_KPIS_REQUESTED:
  case FETCH_CHART_KPIS_REQUESTED:
  case FETCH_COMPARISON_KPIS_REQUESTED:
  case FETCH_KPI_REQUESTED:
  case FETCH_CLOSED_KPIS_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
})

  case CREATE_KPI_REQUESTED:
  case UPDATE_KPI_REQUESTED:
  case DELETE_KPI_REQUESTED:
  case SORT_KPIS_REQUESTED:
    return Object.assign({}, state, {
      isUpdating: true,
      isUpdateFailed: false,
    })

  case FETCH_KPIS_FAILED:
  case FETCH_GROUP_KPIS_FAILED:
  case FETCH_CHART_KPIS_FAILED:
  case FETCH_COMPARISON_KPIS_FAILED:
  case FETCH_KPI_FAILED:
  case FETCH_CLOSED_KPIS_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case CREATE_KPI_FAILED:
  case UPDATE_KPI_FAILED:
  case DELETE_KPI_FAILED:
  case SORT_KPIS_FAILED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: true,
    })

  case FETCH_KPIS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: action.results
    })

  case FETCH_CHART_KPIS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      chart_items: action.results
    })
  
  case FETCH_GROUP_KPIS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      group_items: action.results
    })

  case FETCH_COMPARISON_KPIS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      comparison_items: action.results
    })

  case FETCH_KPI_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: mergeArray('kpi_id', state.items, [action.results])
    })

  case FETCH_CLOSED_KPIS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      closedItems: action.offset > 0 ? mergeArray('kpi_id', state.closedItems, action.results) : action.results,
      hasMoreClosedItems: action.results.length == 10
    })

  case CREATE_KPI_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: mergeArray('kpi_id', state.items, [action.results])
    })

  case UPDATE_KPI_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: mergeArray('kpi_id', state.items, [action.results])
    })

  case DELETE_KPI_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: deleteArray('kpi_id', state.items, action.results.kpi_id),
      closedItems: deleteArray('kpi_id', state.closedItems, action.results.kpi_id)
    })

  case SORT_KPIS_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: action.results,
    })

  case CLEAR_KPIS:
    return initialState

  case CLEAR_CLOSED_KPIS:
    return Object.assign({}, state, {
      closedItems: undefined,
      scrollPosition: undefined
    })

  case KEEP_SCROLL_POSITION:
    return Object.assign({}, state, {
      scrollPosition: action.offset
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/kpi-reducer.js